import { createSelector } from 'reselect'

import { currentUserIdSelector } from './index'

export const hasChatSelector = (state, consultantId) => {
  try {
    return Object.keys(state.rooms).some(roomId => {
      const members = Object.keys(state.rooms[roomId].members)
      return (
        members.length === 2 &&
        members.includes(consultantId) &&
        members.includes(currentUserIdSelector(state))
      )
    })
  } catch (e) {
    return undefined
  }
}

export const chatIdSelector = (state, consultantId) => {
  try {
    return Object.keys(state.rooms).find(roomId => {
      const members = Object.keys(state.rooms[roomId].members)
      return (
        members.length === 2 &&
        members.includes(consultantId) &&
        members.includes(currentUserIdSelector(state))
      )
    })
  } catch (e) {
    return undefined
  }
}

export const roomIdsSelector = state => {
  try {
    return Object.keys(state.auth.user.rooms)
  } catch (e) {
    return undefined
  }
}

export const chatIsPendingSelector = state => {
  try {
    return roomIdsSelector(state).some(
      roomId => state.rooms[roomId] === undefined || state.rooms[roomId].pending
    )
  } catch (e) {
    return undefined
  }
}

export const messagesIsPending = (state, roomId) => {
  try {
    return state.messages[roomId].pending
  } catch (e) {
    return undefined
  }
}

export const firstTimeChatVisitSelector = state => {
  try {
    return !state.auth.user.visit.chat
  } catch (e) {
    return true
  }
}

export const roomTypeSelector = (state, roomId) => {
  try {
    return state.rooms[roomId].type
  } catch (e) {
    return undefined
  }
}

export const roomNotificationCountSelector = (state, roomId) => {
  try {
    const count = state.rooms[roomId].members[currentUserIdSelector(state)]
    return Number.isInteger(count) ? count : 0
  } catch (e) {
    return undefined
  }
}

export const chatNotificationCountSelector = state => {
  try {
    return Object.keys(state.auth.user.rooms)
      .map(roomId => roomNotificationCountSelector(state, roomId))
      .reduce((count, n) => count + n, 0)
  } catch (e) {
    return undefined
  }
}

export const roomIsPendingSelector = createSelector(
  state => state.userInfo,
  userInfo => Object.keys(userInfo).some(id => userInfo[id].pending)
)



// WEBPACK FOOTER //
// ./src/selectors/chat.js